import { observable } from "mobx";
import ChargeEmailAddressChangeRejectionReason from "./chargeEmailAddressChangeRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class EmailAddressChangePermittedActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  rejectionReason?: ChargeEmailAddressChangeRejectionReason;
}
